"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormHelperTheme = void 0;
exports.createFormHelperTheme = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            fontFamily: "Gilroy",
            fontSize: 12,
            lineHeight: "10px",
            paddingTop: 10,
            "&$error": {
                textAlign: "right",
            },
        },
        error: {},
    });
};
